import React,{useState} from "react";
import { Button } from "@mui/material";
import FormField, { validateField } from "./FormField";
import axios from "axios";
import "./style.css";
import { toast } from "react-toastify";
import useApi from "../useApi";

const Form = (props) => {
  const inputFields = props.inputFields;
  const fieldDefault = props.data ? props.data : [];
  const submitBtnTitle = props.submitBtnTitle ? props.submitBtnTitle : "Submit";
  const [externalErrors, setExternalErrors] = useState({});
  
  const {Get, Post, Patch} = useApi();

  async function handleSubmit(e) {
    e.preventDefault();
    let isFormValid = true;
    const newExternalErrors = {};
    inputFields.forEach((field) => {
      const fieldName = field.name;
      const value = e.target.elements[fieldName].value;
      const validationError = validateField(value, field.type, field.label);
      
     
      if (field.required) { // Check if the field is required
        const validationError = validateField(value, field.type, field.label);
        if (validationError) {
          newExternalErrors[fieldName] = validationError;
          toast.error(validationError);
          isFormValid = false;
        }
      }
    });

    setExternalErrors(newExternalErrors);

    if (!isFormValid) {
      return; // Don't submit if form is invalid
    }

    var data = new FormData(e.target);
    let formData = Object.fromEntries(
      Array.from(data.entries()).filter(([_, v]) => v !== "")
    );
    // console.log(formData);

    if (fieldDefault["id"]) {
      
      try{
        await Patch(props.api,fieldDefault["id"], formData).then(()=>{
          props.closeDrawer();
          props.refreshData();
          toast.success("Record updated successfully!");
        })
        .catch((err) => {
          // console.error(err);
          toast.error(err || "Error");
        });
      }catch{
        toast.error("Something Went wrong contact Humbingo");
      }
     
      // axios
      //   .patch(props.api + `${fieldDefault["id"]}` + "/", formData)
      //   .then((response) => {
      //     props.closeDrawer();
      //     props.refreshData();
      //     toast.success("Record updated successfully!");
      //   })
      //   .catch((err) => {
      //     // console.error(err);
      //     toast.error(err.response?.data?.error || "An error occurred");
      //   });
    } else {

         
      try{
        await Post(props.api, formData).then(()=>{
          props.closeDrawer();
          props.refreshData();

          toast.success("Record created successfully!");
        })
        .catch((err) => {
          // console.error(err);
          toast.error(err.response?.data?.error || "Error");
        });
      }catch{
        toast.error("Something Went wrong contact Humbingo");
      }
      // axios
      //   .post(props.api, formData)
      //   .then((response) => {
      //     props.closeDrawer();
      //     props.refreshData();

      //     toast.success("Record created successfully!");
      //   })
      //   .catch((err) => {
      //     // console.error(err);
      //     toast.error(err.response?.data?.error || "An error occurred");
      //   });
    }
  }
  return (
    <form onSubmit={handleSubmit} style={{ padding: "20px" }}>
      {inputFields.map((field, index) => {
        const fieldName = field["name"];
        if (props.grid) {
          return (
            <div className={props.grid}>
              <div className="dynamic-form-element" key={index}>
                <FormField
                  field={field}
                  name={index}
                  defaultValue={fieldDefault[fieldName]}
                  defaultObj={
                    field.type === 'advance-select' && field.defaultLabelKey
                      ? { [field.search.key]: fieldDefault[fieldName], [field.search.label]: fieldDefault[field.defaultLabelKey] }
                      : field.defaultObj
                  }
                  handleChange={props.handleChange}
                />
              </div>
            </div>
          );
        } else {
          return (
            <div className="dynamic-form-element" key={index}>
              <FormField
                field={field}
                name={index}
                defaultValue={fieldDefault[fieldName]}
                defaultObj={
                  field.type === 'advance-select' && field.defaultLabelKey
                    ? { [field.search.key]: fieldDefault[fieldName], [field.search.label]: fieldDefault[field.defaultLabelKey] }
                    : field.defaultObj
                }
                handleChange={props.handleChange}
              />
            </div>
          );
        }
      })}
      <br />
      <Button variant="contained" type="submit" size="small">
        {submitBtnTitle}
      </Button>
    </form>
  );
};
export default Form;
